import { getChildRoutes } from "@/helpers/routes/getChildRoutes";
import { GetRelativeRoutes } from "@/entities/GetChildRoutes";
import RouteNames from "@/entities/RouteNames";
import Roles from "@/entities/Roles";
import BreadcrumbsTitles from "@/entities/BreadcrumbsTitles";
import NavigationIcons from "@/entities/NavigationIcons";
import RouteWrapper from "@/components/common/RouteWrapper.vue";
import RouteSectionsPrefixes from "@/entities/RouteSectionsPrefixes";

const Contractor = () =>
  import("@/views/manage/Contractor.vue").then((m) => m.default);
const ContractorAbout = () =>
  import("@/views/manage/contractorDetails/AboutNew.vue").then(
    (m) => m.default
  );
const ContractorArchived = () =>
  import("@/views/companyContractors/Archived.vue").then((m) => m.default);
const ContractorDocuments = () =>
  import("@/views/manage/contractorDetails/DocumentsNew.vue").then(
    (m) => m.default
  );
const ContractorProjects = () =>
  import("@/views/manage/contractorDetails/ProjectsNew.vue").then(
    (m) => m.default
  );
const ContractorNotes = () =>
  import("@/views/manage/contractorDetails/NotesNew.vue").then(
    (m) => m.default
  );
const ContractorManagers = () =>
  import("@/views/manage/contractorDetails/ManagersNew.vue").then(
    (m) => m.default
  );
const ContractorReviews = () =>
  import("@/views/manage/contractorDetails/ReviewsNew.vue").then(
    (m) => m.default
  );

const ContarctorAdditionalInfo = () =>
  import("@/views/manage/contractorDetails/ContarctorAdditionalInfo.vue").then(
    (m) => m.default
  );

const ContractorVisits = () =>
  import("@/views/manage/contractorDetails/ContractorVisits.vue").then(
    (m) => m.default
  );

const ContractorPublicPage = () =>
  import("@/views/marketplace/ContractorPublicPage.vue").then((m) => m.default);
const CompanyContractorsDB = () =>
  import("@/views/companyContractors/CompanyContractorsDBNew.vue").then(
    (m) => m.default
  );
const CompanyContractorsPending = () =>
  import("@/views/companyContractors/Pending.vue").then((m) => m.default);
const TalentMapping = () =>
  import("@/views/companyContractors/TalentMappingV2.vue").then(
    (m) => m.default
  );
// const TalentMappingDepricated = () =>
//   import("@/views/companyContractors/TalentMapping.vue").then((m) => m.default);

const MarketplaceContractors = () =>
  import("@/views/marketplace/MarketplaceContractors.vue").then(
    (m) => m.default
  );

const FavoriteContractors = () =>
  import("@/views/companyContractors/MyFavorites.vue").then((m) => m.default);
const AdminContractorsTabContainer = () =>
  import("@/views/companyContractors/AdminContractorsTabContainerNew.vue").then(
    (m) => m.default
  );
const Requests = () =>
  import("@/views/companyContractors/RequestsNew.vue").then((m) => m.default);
const CustomRequests = () =>
  import("@/views/companyContractors/CustomRequestsNew.vue").then(
    (m) => m.default
  );

const getCompanyContractorsDatabaseRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "/company_database",
    component: RouteWrapper,
    meta: {
      breadcrumb: {
        // title: window.location.pathname.includes('timesheet')
        // 	? ''
        // 	: 'Company Resources',
        title: "Company Resources",
        // icon: NavigationIcons.DATABASE,
        routeName: RouteNames.COMPANY_DATABASE,
        prefix: RouteSectionsPrefixes.COMPANY_DATABASE__CONTRACTORS,
        copyLink: false,
        isStyled: true,
      },
    },
  },
]);

const getCompanyContractorsDatabaseTabsRoutes: GetRelativeRoutes =
  getChildRoutes([
    {
      path: "",
      component: AdminContractorsTabContainer,
      meta: {
        roles: [Roles.ADMIN, Roles.MANAGER],
        breadcrumb: {
          isStyled: true,
        },
      },
      children: [
        {
          path: "",
          name: RouteNames.COMPANY_DATABASE,
          redirect: {
            name: RouteNames.COMPANY_DATABASE_CONTRACTORS,
          },
        },
      ],
    },
  ]);

const getCompanyContractorsRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "contractors",
    name: RouteNames.COMPANY_DATABASE_CONTRACTORS,
    component: CompanyContractorsDB,
    meta: {
      title: "Company contractors",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        title: BreadcrumbsTitles.COMPANY_DATABASE,
        // icon: NavigationIcons.DATABASE,
        routeName: RouteNames.COMPANY_DATABASE,
        prefix: RouteSectionsPrefixes.COMPANY_DATABASE__CONTRACTORS,
        copyLink: false,
        isStyled: true,
      },
    },
  },
]);

// const getTalentMappingRoutes: GetRelativeRoutes = getChildRoutes([
//   {
//     path: "talent-mapping",
//     name: RouteNames.TALENT_MAPPING,
//     component: TalentMapping,
//     meta: {
//       title: "Talent Mapping",
//       roles: [Roles.ADMIN, Roles.MANAGER],
//         breadcrumb: {
//         title: BreadcrumbsTitles.TALENT_MAPPING,
//         icon: NavigationIcons.LOCATION,
//         routeName: RouteNames.TALENT_MAPPING,
//         prefix: RouteSectionsPrefixes.COMPANY_DATABASE__CONTRACTORS,
//         copyLink: true,
//       },
//     },
//   },
// ]);

const getTalentMappingRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "/talent-mapping",
    component: TalentMapping,
    meta: {
      title: "Talent Mapping",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        title: BreadcrumbsTitles.TALENT_MAPPING,
        routeName: RouteNames.TALENT_MAPPING,
        prefix: RouteSectionsPrefixes.TALENT_MAPPING,
        isStyled: true,
      },
    },

    children: [
      {
        path: "",
        name: RouteNames.TALENT_MAPPING,
        component: TalentMapping,
        meta: {
          title: "Talent Mapping",
          roles: [Roles.ADMIN, Roles.MANAGER],
          breadcrumb: {
            routeName: RouteNames.TALENT_MAPPING,
            prefix: RouteSectionsPrefixes.TALENT_MAPPING,
            isStyled: true,
          },
        },
      },
    ],
  },
  // {
  //   path: "/talent-mapping-depricated",

  //   component: RouteWrapper,

  //   meta: {
  //     title: "Talent Mapping",

  //     breadcrumb: {
  //       title: BreadcrumbsTitles.TALENT_MAPPING,

  //       icon: NavigationIcons.LOCATION,

  //       routeName: RouteNames.TALENT_MAPPING,

  //       prefix: RouteSectionsPrefixes.TALENT_MAPPING,
  //       isStyled: true,
  //     },
  //   },

  //   children: [
  //     {
  //       path: "",

  //       name: RouteNames.TALENT_MAPPING,

  //       component: TalentMappingDepricated,

  //       meta: {
  //         title: "Talent Mapping",

  //         roles: [Roles.ADMIN, Roles.MANAGER],
  //         breadcrumb: {
  //           isStyled: true,
  //         },
  //       },
  //     },
  //   ],
  // },
]);

const getCompanyContractorsRequestsRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "/company_database/requests",
    name: RouteNames.CONTRACTORS_REQUESTS,
    component: Requests,
    meta: {
      title: "Requests",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        title: BreadcrumbsTitles.COMPANY_DATABASE,
        isStyled: true,
      },
    },
  },
]);

const getCompanyContractorsArchived: GetRelativeRoutes = getChildRoutes([
  {
    path: "/company_database/archived",
    name: RouteNames.CONTRACTOR_ARCHIVED,
    component: ContractorArchived,
    meta: {
      title: "Archived",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        title: BreadcrumbsTitles.COMPANY_DATABASE,
        isStyled: true,
      },
    },
  },
]);

const getCompanyContractorsCustomRequestsRoutes: GetRelativeRoutes =
  getChildRoutes([
    {
      path: "/company_database/custom-requests",
      name: RouteNames.CUSTOM_REQUESTS,
      component: CustomRequests,
      meta: {
        title: "Custom Requests",
        roles: [Roles.ADMIN, Roles.MANAGER],
        breadcrumb: {
          title: BreadcrumbsTitles.COMPANY_DATABASE,
          isStyled: true,
        },
      },
    },
  ]);

const getCompanyContractorsCustomPendingRoutes: GetRelativeRoutes =
  getChildRoutes([
    {
      path: "/company_database/pending",
      name: RouteNames.CONTRACTOR_PENDING,
      component: CompanyContractorsPending,
      meta: {
        title: "Invite not sent",
        roles: [Roles.ADMIN, Roles.MANAGER],
        breadcrumb: {
          title: BreadcrumbsTitles.COMPANY_DATABASE,
          isStyled: true,
        },
      },
    },
  ]);

const getMyFavoritesContractorsRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "/company_database/favourites",
    name: RouteNames.CONTRACTOR_FAV,
    component: FavoriteContractors,
    meta: {
      title: "Favorites",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        title: BreadcrumbsTitles.FAVORITE,
        isStyled: true,
      },
    },
  },
]);

const getManagerContractorsDatabaseRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "/my_database/",
    component: RouteWrapper,
    meta: {
      breadcrumb: {
        title: BreadcrumbsTitles.MY_CONTRACTORS,
        // icon: NavigationIcons.MY_CONTRACTOR_DATABASE,
        routeName: RouteNames.MANAGER_CONTRACTOR_DATABASE,
        prefix: RouteSectionsPrefixes.MY_DATABASE,
        isStyled: true,
      },
    },
    children: [
      {
        path: "",
        name: RouteNames.MANAGER_CONTRACTOR_DATABASE,
        component: CompanyContractorsDB,
        props: {
          managerDatabase: true,
        },
        meta: {
          title: "My Contractors",
          roles: [Roles.MANAGER],
          breadcrumb: {
            isStyled: true,
          },
        },
      },
    ],
  },
]);

const getMarketplaceContractorsRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "/marketplace",
    component: RouteWrapper,
    props: true,
    meta: {
      title: "Marketplace",
      breadcrumb: {
        title: BreadcrumbsTitles.MARKETPLACE,
        routeName: RouteNames.MARKETPLACE_CONTRACTORS,
        prefix: RouteSectionsPrefixes.MARKETPLACE,
        isStyled: true,
      },
    },
    children: [
      {
        path: "",
        name: RouteNames.MARKETPLACE_CONTRACTORS,
        component: MarketplaceContractors,
        meta: {
          roles: [Roles.ADMIN, Roles.MANAGER],
          breadcrumb: {
            isStyled: true,
            prefix: RouteSectionsPrefixes.COMPANY_DATABASE__CONTRACTORS,
          },
        },
      },
    ],
  },
]);

// const getMyFavoritesContractorsRoutes: GetRelativeRoutes = getChildRoutes([
//   {
//     path: "/my_favorites",
//     component: RouteWrapper,
//     meta: {
//       title: "My Favorites",
//       breadcrumb: {
//         title: BreadcrumbsTitles.MY_FAVORITES,
//         icon: NavigationIcons.FAVORITE,
//         routeName: RouteNames.MY_FAVORITES,
//         prefix: RouteSectionsPrefixes.MY_FAVORITES,
//       },
//     },
//     children: [
//       {
//         path: "",
//         name: RouteNames.MY_FAVORITES,
//         component: FavoriteContractors,
//         meta: {
//           title: "My Favorites",
//           roles: [Roles.ADMIN, Roles.MANAGER],
//         },
//       },
//     ],
//   },
// ]);

// const getMyFavoritesContractorsRoutes: GetRelativeRoutes = getChildRoutes([
//   {
//     path: "/my_favorites",

//     component: RouteWrapper,

//     meta: {
//       title: "My Favorites",

//       breadcrumb: {
//         title: BreadcrumbsTitles.MY_FAVORITES,

//         icon: NavigationIcons.FAVORITE,

//         routeName: RouteNames.MY_FAVORITES,

//         prefix: RouteSectionsPrefixes.MY_FAVORITES,
//         isStyled: true,
//       },
//     },

//     children: [
//       {
//         path: "",

//         name: RouteNames.MY_FAVORITES,

//         component: FavoriteContractors,

//         meta: {
//           title: "My Favorites",

//           roles: [Roles.ADMIN, Roles.MANAGER],
//           breadcrumb: {
//             isStyled: true,
//           },
//         },
//       },
//     ],
//   },
// ]);

const getContractorPublicPageRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: ":id",
    name: RouteNames.CONTRACTOR_PUBLIC_PAGE,
    component: ContractorPublicPage,
    props: true,
    meta: {
      title: "Talent Directory",
      roles: [Roles.ADMIN , Roles.MANAGER],
      breadcrumb: {
        title: "Talent Directory",
        routeName: RouteNames.COMPANY_DATABASE,
        classes: "contractor_detail_crubm",
        isStyled: true,
      },
    },
  },
]);

const getContractorPrivatePageTabsRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "about",
    name: RouteNames.CONTRACTOR_DETAILS_ABOUT,
    component: ContractorAbout,
    meta: {
      title: "About Contractor",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        title: "About",
        classes: "contractor_detail_crubm",
        isStyled: true,
      },
    },
  },
  {
    path: "projects",
    name: RouteNames.CONTRACTOR_DETAILS_PROJECTS,
    component: ContractorProjects,
    meta: {
      title: "Contractor Projects",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        title: "Clients",
        classes: "contractor_detail_crubm",
        isStyled: true,
      },
    },
  },
  {
    path: "visits",
    name: RouteNames.CONTRACTOR_DETAILS_VISITS,
    component: ContractorVisits,
    meta: {
      title: "Contractor Visits",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        title: "Visits",
        classes: "contractor_detail_crubm",
        isStyled: true,
      },
    },
  },
  {
    path: "managers",
    name: RouteNames.CONTRACTOR_DETAILS_MANAGERS,
    component: ContractorManagers,
    meta: {
      title: "Contractor Managers",
      roles: [Roles.ADMIN],
      breadcrumb: {
        title: "Managers",
        classes: "contractor_detail_crubm",
        isStyled: true,
      },
    },
  },
  {
    path: "documents",
    name: RouteNames.CONTRACTOR_DETAILS_DOCUMENTS,
    component: ContractorDocuments,
    meta: {
      title: "Contractor Documents",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        title: "Documents",
        classes: "contractor_detail_crubm",
        isStyled: true,
      },
    },
  },
  {
    path: "notes",
    name: RouteNames.CONTRACTOR_DETAILS_NOTES,
    component: ContractorNotes,
    meta: {
      title: "Contractor Notes",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        title: "Notes",
        classes: "contractor_detail_crubm",
        isStyled: true,
      },
    },
  },
  {
    path: "reviews",
    name: RouteNames.CONTRACTOR_DETAILS_REVIEWS,
    component: ContractorReviews,
    meta: {
      title: "Contractor Rating",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        title: "Rating",
        classes: "contractor_detail_crubm",
        isStyled: true,
      },
    },
  },
  {
    path: "additional-info",
    name: RouteNames.CONTRACTOR_DETAILS_INFO,
    component: ContarctorAdditionalInfo,
    meta: {
      title: "Contractor Additional Info",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        title: "Additional Info",
        classes: "contractor_detail_crubm",
        isStyled: true,
      },
    },
  },
]);

const getContractorPrivatePageRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "contractors/:id",
    component: Contractor,
    props: true,
    meta: {
      title: "Contractor",
      roles: [Roles.ADMIN, Roles.MANAGER],
      breadcrumb: {
        // title: BreadcrumbsTitles.CONTRACTOR_DETAILS,
        title: BreadcrumbsTitles.COMPANY_DATABASE,
        // breadcrumb: {
        //   // icon: NavigationIcons.DATABASE,
        routeName: RouteNames.COMPANY_DATABASE_CONTRACTORS,
        isStyled: true,
      },
    },
  },
]);

export {
  getContractorPublicPageRoutes,
  getContractorPrivatePageRoutes,
  getContractorPrivatePageTabsRoutes,
  getManagerContractorsDatabaseRoutes,
  getMarketplaceContractorsRoutes,
  getMyFavoritesContractorsRoutes,
  getCompanyContractorsDatabaseRoutes,
  getCompanyContractorsDatabaseTabsRoutes,
  getCompanyContractorsRoutes,
  getCompanyContractorsRequestsRoutes,
  getCompanyContractorsCustomRequestsRoutes,
  getCompanyContractorsCustomPendingRoutes,
  getTalentMappingRoutes,
  getCompanyContractorsArchived,
};
